import React from 'react'
import { css } from '@emotion/css'

const containerCss = (width: number) => css`
  display: flex;
  overflow: hidden;
  margin-right: 25px;
  /* Enables the truncation mentioned below. Table width minus the other columns. */
  max-width: ${width - 350}px;
`

const innerContainerCss = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  direction: rtl;
  line-height: normal;
`

export const nameCellTestID = 'name-cell-test-id'

export function getNameCellRenderer({
  name,
  tableWidth
}: {
  name: string
  tableWidth: number
}) {
  return (
    <div className={containerCss(tableWidth)}>
      {/* Because this cell renders file paths, if the string is too long for
            the cell, we want to truncate the text on the left side of the string
            so that the user can see the end of the string.

            We do this by using the `direction: rtl` property to reverse the
            truncation of the string. We then use the left-to-right mark &lrm;
            to prevent slashes from the beginning of the file path from being
            moved to the end of the string */}
      <div data-testid={nameCellTestID} className={innerContainerCss}>
        &lrm;
        {name}
        &lrm;
      </div>
    </div>
  )
}
